import echarts from 'echarts';
import { RQ } from 'utils';

export default {
  async init() {
    const res = await RQ.mall.get('/api/app/skin/tester/report', { type:2 }, {enterprise: '', loading: false});
    if(res.code === 0) {
      this.reportData = res;
      if(this.reportData.data) {
        const skinReport = JSON.parse(this.reportData.data.report);
        this.headImg = skinReport.headImg;
        this.skinReportData = JSON.parse(skinReport.report);
        this.commonConclusion = this.getConclusionText(this.skinReportData.skin_risk_factor);

        this.skinReportData.nine_dimensionality = this.skinReportData.nine_dimensionality.map(i => {
          if(i.name === '水分') {
            i.name = '干燥度';
            i.percent = parseFloat((100 - i.percent).toFixed(2));
          }
          return i
        })

        this.liveImg = this.getLiveImg(skinReport.reportImgs);
        this.ageNum = parseInt(this.skinReportData.skin_age);

        this.$nextTick(() => {
          this.skinAgeProgress = this.ageNum;
        })
        this.timer = setInterval(() => {
          this.skinAge = this.skinAge + 2;
          if(this.skinAge >= this.ageNum) {
            this.skinAge = this.ageNum;
            clearInterval(this.timer);
          }
        }, 60);
      }
    }
  },
  initRadarChart() {
    let myChart = echarts.init(document.getElementById('radar'));
    const indicator = this.skinReportData.radar_map.map(i => {
      return {name: `${i.name}\n${i.percent}`,max: 100}
    })
    const valArr = this.skinReportData.radar_map.map(k => {
      const percent = parseFloat(k.percent)
      return percent
    })
    const option = {
      title: {},
      tooltip: {},
      legend: {
          // data: ['皮肤健康综合状况数据']
      },
      radar: {
        shape: 'circle',
        silent: true,
        name: {
            textStyle: {
                color: '#000',
                backgroundColor: 'rgba(255,255,255,0)',
                borderRadius: 3,
                padding: [3, 5]
            }
        },
        indicator: indicator,
        radius: '60%',
        splitNumber: 0,
        axisLine: {
          show: false
        },
        startAngle: 90,
        splitNumber: 3,
        splitLine: {
          lineStyle: {
            color: '#ff6f61'
          }
        },
        splitArea: {
          areaStyle: {
            color: ['rgba(255, 255, 255, 0.2)','rgba(255, 255, 255, 0.2)'],
          }
        },
      },
      series: [{
          name: '',
          type: 'radar',
          data : [
            {
              value : valArr,
            },
          ],
          symbol: 'none',
          lineStyle: {
            normal: {
              color: '#ff6f61'
            }
          },
          areaStyle: {
            normal: {
              opacity: 0.5,
              color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                  {
                      color: '#ffe2e0',
                      offset: 0
                  },
                  {
                      color: '#ffe2e0',
                      offset: 1
                  }
              ])
            }
          }
      }],
      tooltip: {
        show: false,
      }
    };
    myChart.setOption(option);
  },
  initLineChart() {
    let myChart = echarts.init(document.getElementById('line-chart'));
    let xAxisData = ['周一','周二','周三','周四','周五','周六','周日'];
    xAxisData = xAxisData.map(i => {
      return {value:i,textStyle:{color:'#666'}}
    })
    
    const option = {
      tooltip: {
        show: true,
        backgroundColor: 'rgba(255, 238, 237, 0.9)',
        textStyle: {
          color: '#ff6f61',
        },
        padding: [10,10],
        confine: true,
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '4%',
        top: '10%',
        containLabel: true
      },
      xAxis : [
        {
          type : 'category',
          boundaryGap : false,
          data : xAxisData,
          axisLine: {
            lineStyle: {
              color: '#ff6f61'
            },
          },
          axisPointer: {
            show: true,
          }
        }
      ],
      yAxis : [
        {
          type : 'value',
          silent: true,
          interval: 20,
          max: 100,
          min: 0,
          axisLine: {
            lineStyle: {
              color: '#ff6f61'
            },
          },
          splitLine: {
            show: false,
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['#fca8a0','#fca8a0','#fec5c1','#fec5c1','#ffe2e0']
            }
          }
        }
      ],
      series : [
        {
          name:'皮肤综合得分',
          type:'line',
          label: {
              normal: {
                  show: true,
                  position: 'top'
              }
          },
          data:[0, 42, 60.1, 53.4, 40, 38, 19.5]
        }
      ]
    };

    myChart.setOption(option);
  },
  getConclusionText(arrData) {
    let arr = [];
    arrData.forEach(item => {
      if(item.description != '') {
        let strArr = item.description.split('\n');
        arr = arr.concat(strArr);
      }
    })
    let objArr = arr.map(i => {
      let strArr = i.split('，');
      const firstStr = strArr.shift();
      let obj = {}
      obj.key = firstStr;
      obj.text = strArr.join('，');
      return obj
    })
    return objArr
  },
  getLiveImg(imgObj) {
    let imgUrl = '';
    for (const key in imgObj) {
      if (imgObj.hasOwnProperty(key)) {
        key === 'whiteSpot' ? imgUrl = imgObj[key] : '';
      }
    }
    return imgUrl
  }
}



// WEBPACK FOOTER //
// ./src/module/app/skinReport/action.js